import { useEffect, useState } from "react";
import { Trash2, Download, AlertTriangle } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import api, { downloadFile } from "../../lib/api";
import { toast } from "sonner";

export default function CleanupPanel() {
  const [prev, setPrev] = useState(null);
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/cleanup/preview").then(({ data }) => setPrev(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/cleanup", { confirm });
      toast.success(`Eliminati ${data.total} record di prova`);
      setConfirm(""); setOpen(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Eliminazione fallita"); } finally { setBusy(false); }
  };
  const rows = (prev?.items || []).filter((i) => i.count > 0);
  return (
    <div className="bg-white rounded-2xl border border-red-200 p-6" data-testid="cleanup-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h3 className="font-serif text-xl font-semibold text-[#0B2A45] flex items-center gap-2"><Trash2 className="w-5 h-5 text-red-600" />Elimina dati di prova</h3>
        <span className="text-sm text-stone-500" data-testid="cleanup-total">{prev ? `${prev.total} record da eliminare` : "…"}</span>
      </div>
      <p className="text-sm text-stone-500 mb-4">Cancella ordini, comodati, movimenti, clienti e utenti non admin. Restano prodotti ({prev?.keep?.products ?? "…"}), macchine ({prev?.keep?.machines ?? "…"}), iscritti newsletter ({prev?.keep?.newsletter_subscribers ?? "…"}), foto e contenuti del sito. Operazione irreversibile: scarica prima il backup.</p>
      {rows.length > 0 ? (
        <ul className="grid sm:grid-cols-2 gap-x-6 text-sm mb-4" data-testid="cleanup-preview">
          {rows.map((i) => <li key={i.collection} className="flex justify-between border-b border-stone-100 py-1"><span className="text-stone-600">{i.label}</span><b className="text-[#0B2A45]">{i.count}</b></li>)}
        </ul>
      ) : prev && <p className="text-sm text-emerald-700 mb-4" data-testid="cleanup-empty">Nessun dato di prova presente.</p>}
      <div className="flex flex-wrap gap-3">
        <Button variant="outline" className="rounded-full" onClick={() => downloadFile("/admin/cleanup/backup.json", "backup_dati_prova.json")} data-testid="cleanup-backup-btn"><Download className="w-4 h-4 mr-2" />Scarica backup JSON</Button>
        {!open ? (
          <Button variant="destructive" className="rounded-full" disabled={!prev || prev.total === 0} onClick={() => setOpen(true)} data-testid="cleanup-open-btn"><Trash2 className="w-4 h-4 mr-2" />Elimina…</Button>
        ) : (
          <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto" data-testid="cleanup-confirm-box">
            <AlertTriangle className="w-4 h-4 text-red-600" />
            <Input value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Digita ELIMINA" className="w-40 rounded-full" data-testid="cleanup-confirm-input" />
            <Button variant="destructive" className="rounded-full" disabled={busy || confirm.trim().toUpperCase() !== "ELIMINA"} onClick={run} data-testid="cleanup-run-btn">{busy ? "Elimino…" : "Conferma eliminazione"}</Button>
            <Button variant="ghost" className="rounded-full" onClick={() => { setOpen(false); setConfirm(""); }} data-testid="cleanup-cancel-btn">Annulla</Button>
          </div>
        )}
      </div>
    </div>
  );
}
